import {
    FETCH_BUSINESS_UNIT_FAILURE,
    FETCH_BUSINESS_UNIT_REQUEST,
    FETCH_BUSINESS_UNIT_SUCCESS,
    UPDATE_BUSINESS_UNIT_REQUEST,
    UPDATE_BUSINESS_UNIT_SUCCESS,
    UPDATE_BUSINESS_UNIT_FAILURE,
    CREATE_BUSINESS_UNIT_REQUEST,
    CREATE_BUSINESS_UNIT_SUCCESS,
    CREATE_BUSINESS_UNIT_FAILURE
} from './types';

/**
 *
 * @param {Object} [params]
 * @returns
 */
export const fetchBusinessUnitRequest = (params) => ({
    type: FETCH_BUSINESS_UNIT_REQUEST,
    payload: params
});

/**
 *
 * @param {Object} [params]
 * @returns
 */
export const fetchBusinessUnitSuccess = (params) => ({
    type: FETCH_BUSINESS_UNIT_SUCCESS,
    payload: params
});

/**
 *
 * @param {string} error
 * @returns
 */
export const fetchBusinessUnitFailure = (error) => ({
    type: FETCH_BUSINESS_UNIT_FAILURE,
    error
});

/**
 *
 * @param {Object} [params]
 * @returns
 */
 export const createBusinessUnit = (params) => ({
    type: CREATE_BUSINESS_UNIT_REQUEST,
    payload: params
});

export const createBusinessUnitSuccess = (data) => ({
    type: CREATE_BUSINESS_UNIT_SUCCESS,
    payload: data
});

/**
 *
 * @param {String} error
 * @returns
 */
export function createBusinessUnitFailure(error) {
    return {
        type: CREATE_BUSINESS_UNIT_FAILURE,
        error
    };
}

/**
 *
 * @param {BusinessUnit} params
 * @returns
 */
export const updateBusinessUnit = (params) => ({
    type: UPDATE_BUSINESS_UNIT_REQUEST,
    payload: params
});

export const updateBusinessUnitSuccess = (data) => ({
    type: UPDATE_BUSINESS_UNIT_SUCCESS,
    payload: data
});

/**
 *
 * @param {String} error
 * @returns
 */
export function updateBusinessUnitFailure(error) {
    return {
        type: UPDATE_BUSINESS_UNIT_FAILURE,
        error
    };
}

